import React, { useMemo, useState } from 'react';
import Chart from 'react-apexcharts';
import { SkeletonAreaChartCard } from '../../util/skeleton/Skeleton';

const RevenueTrendsChart = ({ revenueData }) => {
  const [view, setView] = useState('Monthly');
  const isLoading = !revenueData;

  // Safe getters for categories/revenue
  const categories = useMemo(() => {
    if (isLoading) return [];
    const block = revenueData[view] || { categories: [], revenue: [] };
    return Array.isArray(block.categories) ? block.categories : [];
  }, [isLoading, revenueData, view]);

  const seriesData = useMemo(() => {
    if (isLoading) return [];
    const block = revenueData[view] || { categories: [], revenue: [] };
    return Array.isArray(block.revenue) ? block.revenue : [];
  }, [isLoading, revenueData, view]);

  const chartOptions = useMemo(() => ({
    chart: {
      id: 'revenue-trends',
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    colors: ['#6366f1'], // Indigo
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'dark',
        type: 'vertical',
        gradientToColors: ['#03a7ea'], // Blue
        stops: [0, 100],
      },
    },
    dataLabels: { enabled: false },
    stroke: { curve: 'smooth', width: 2 },
    xaxis: {
      categories,
      labels: { style: { colors: '#cbd5e1' } },
    },
    yaxis: {
      labels: { style: { colors: '#cbd5e1' } },
    },
    grid: { borderColor: '#334155' },
    tooltip: { theme: 'dark' },
  }), [categories]);

  const chartSeries = useMemo(() => ([
    {
      name: 'Revenue ($)',
      data: seriesData,
    },
  ]), [seriesData]);

  if (isLoading) {
    return <SkeletonAreaChartCard />;
  }

  return (
    <div className="card custom-card overflow-hidden">
      <div className="card-body">
        <div className="card-option d-flex">
          <div>
            <h6 className="card-title mb-1">Revenue Trends</h6>
            <p className="text-muted card-sub-title">Switch between Weekly and Monthly views</p>
          </div>
          <div className="card-option-title ml-auto">
            <div className="btn-group p-0">
              <button
                className={`btn btn-sm ${view === 'Weekly' ? 'btn-light' : 'btn-outline-light'}`}
                type="button"
                onClick={() => setView('Weekly')}
              >
                Weekly
              </button>
              <button
                className={`btn btn-sm ${view === 'Monthly' ? 'btn-light' : 'btn-outline-light'}`}
                type="button"
                onClick={() => setView('Monthly')}
              >
                Monthly
              </button>
            </div>
          </div>
        </div>

        <div>
          <Chart options={chartOptions} series={chartSeries} type="area" height={320} />
        </div>
      </div>
    </div>
  );
};

export default RevenueTrendsChart;
